import React, {useState, useEffect, useRef} from 'react';
import {generateColumnClass} from "../../Utility";
import SearchInput from "./SearchInput";

const MultiSelectOption = ({
                               name,
                               value,
                               options,
                               error,
                               label,
                               onChange,
                               onBlur,
                               columns,
                               inline,
                               isSearch = false,
                               searchPlaceholder = 'Search...'
                           }) => {
    const columnClass = generateColumnClass(columns);
    const className = `${inline ? 'd-flex flex-wrap ' : ''}col-12${columnClass}`;
    const [searchText, setSearchText] = useState("");
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        if (Array.isArray(value)) {
            const result = value.map(item => {
                if (typeof item === 'string') {
                    return item;
                } else if (typeof item === 'object') {
                    // Look for any key that has a 24-char string value (likely an ID)
                    const id = Object.values(item).find(val =>
                        typeof val === 'string' && /^[a-f0-9]{24}$/i.test(val)
                    );
                    return id || null;
                }
                return null;
            }).filter(Boolean); // remove null/undefined

            setSelectedOptions(result);
        }
    }, [value]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const toggleDropdown = () => setIsOpen(!isOpen);

    const handleOptionToggle = (optionValue) => {
        const newSelected = selectedOptions.includes(optionValue)
            ? selectedOptions.filter((v) => v !== optionValue)
            : [...selectedOptions, optionValue];

        setSelectedOptions(newSelected);

        if (onChange) {
            onChange({
                target: {
                    name,
                    value: newSelected,
                },
            });
        }
    };

    return (
        <div className={className} ref={dropdownRef}>
            {label && (
                <label
                    className={`form-label opacity-75${inline ? ' mb-0 py-2 col-12 col-md-4' : ''}`}
                    htmlFor={name}
                >
                    {label}
                </label>
            )}

            <div className={`select position-relative${inline ? ' col' : ''}`}>
                <div className="form-select select-box" onClick={toggleDropdown}>
                    <span>{selectedOptions.length > 0
                        ? selectedOptions.map((key) => options[key]).join(', ')
                        : '--Please Select--'}</span>
                </div>

                {isOpen && (
                    <div
                        className={`select-options form-control d-flex flex-column position-absolute top-100 z-1 overflow-auto p-3 ${isSearch ? 'pt-0' : ''}`}
                        style={{height: 300}}>
                        {isSearch && (
                                <div className="search-wrapper bg-white py-2 sticky-top">
                                    <SearchInput
                                        value={searchText}
                                        onChange={(e) => setSearchText(e.target.value)}
                                        placeholder={searchPlaceholder}
                                        className="mb-4"
                                        isSearchStyle="true" //set to true only when searchInput is placed inside multiselect(for design purpose)
                                    />
                                </div>
                        )}
                        {Object.keys(options)
                            .filter((key) => {
                                if (!isSearch) return true; // Show all if search is disabled
                                if (!searchText.trim()) return true; // Show all if search box is empty
                                return options[key].toLowerCase().includes(searchText.toLowerCase());
                            })
                            .map((key) => (
                                <label key={key}>
                                    <input
                                        type="checkbox"
                                        value={key}
                                        checked={selectedOptions.includes(key)}
                                        onChange={() => handleOptionToggle(key)}
                                        className="form-check-input me-2 mb-2"
                                    />
                                    {options[key]}
                                </label>
                            ))}
                    </div>
                )}
            </div>

            {error && (
                <div className={`form-text text-start text-danger w-100${inline && label ? ' offset-4' : ''}`}>
                    {error}
                </div>
            )}
        </div>
    );
};

export default MultiSelectOption;
